<template>
  <Dialog
    :title="type === 'add' ? '新增新闻' : '修改新闻'"
    :visible.sync="dialogVisible"
    width="640px"
    :close-on-click-modal="false"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="新闻标题" prop="newsTitle">
        <el-input
          v-model.trim="form.newsTitle"
          maxlength="100"
          show-word-limit
          placeholder="请输入新闻标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="封面" prop="coverImage">
        <UploadFile
          v-model="form.coverImage"
          :limit="1"
          :maxSize="5"
          accept="image/*"
          :fileTypes="['jpg', 'jpeg', 'png', 'gif', 'webp']"
          @input="$refs.formRef && $refs.formRef.validateField('coverImage')"
        ></UploadFile>
      </el-form-item>
      <el-form-item label="来源" prop="source">
        <el-input
          v-model.trim="form.source"
          maxlength="50"
          placeholder="请输入新闻来源"
        ></el-input>
      </el-form-item>
      <el-form-item label="链接" prop="link">
        <el-input
          v-model.trim="form.link"
          maxlength="500"
          placeholder="请输入链接，如 https://..."
        ></el-input>
      </el-form-item>
      <el-form-item label="新闻摘要" prop="newsSummary">
        <el-input
          type="textarea"
          v-model.trim="form.newsSummary"
          :rows="4"
          maxlength="300"
          show-word-limit
          placeholder="请输入新闻摘要"
        ></el-input>
      </el-form-item>
      <el-form-item label="发布时间" prop="publishTime">
        <el-date-picker
          v-model="form.publishTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择发布时间"
          :picker-options="publishTimePickerOptions"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button
        plain
        round
        size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import UploadFile from "@/components/UploadFile";
import { addNews, updateNews, getNewsDetail } from "@/api/content/news";
import { validateUrlOptional } from "@/utils/validate";

const defaultForm = () => ({
  newsId: undefined,
  newsTitle: "",
  coverImage: "",
  source: "",
  link: "",
  newsSummary: "",
  publishTime: ""
});

export default {
  name: "NewsForm",
  components: { UploadFile },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      type: "add",
      form: defaultForm(),
      publishTimePickerOptions: {
        disabledDate(time) {
          const end = new Date();
          end.setHours(23, 59, 59, 999);
          return time.getTime() > end.getTime();
        }
      },
      rules: {
        newsTitle: [
          { required: true, message: "请输入新闻标题", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "标题长度为1~100个字符",
            trigger: "blur"
          }
        ],
        coverImage: [
          { required: true, message: "请上传封面", trigger: "change" }
        ],
        source: [
          { required: true, message: "请输入新闻来源", trigger: "blur" },
          { max: 50, message: "来源不能超过50个字符", trigger: "blur" }
        ],
        link: [
          { required: true, message: "请输入链接", trigger: "blur" },
          { validator: validateUrlOptional, trigger: "blur" }
        ],
        newsSummary: [
          { required: true, message: "请输入新闻摘要", trigger: "blur" },
          { max: 300, message: "摘要不能超过300个字符", trigger: "blur" }
        ],
        publishTime: [
          { required: true, message: "请选择发布时间", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    formatPublishTimeForForm(value) {
      if (!value) return "";
      return String(value).slice(0, 10);
    },
    formatPublishTimeForApi(value) {
      if (!value) return "";
      const day = String(value).slice(0, 10);
      return `${day} 00:00:00`;
    },
    async open(type, row = {}) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit" && row.newsId != null) {
        try {
          const result = await getNewsDetail(row.newsId);
          const data = (result && result.data) || row;
          this.form = {
            newsId: data.newsId,
            newsTitle: data.newsTitle || "",
            coverImage: data.coverImage || "",
            source: data.source || "",
            link: data.link || "",
            newsSummary: data.newsSummary || "",
            publishTime: this.formatPublishTimeForForm(data.publishTime)
          };
        } catch (e) {
          this.cancel();
          return;
        }
      } else {
        this.form = defaultForm();
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      const request = this.form.newsId ? updateNews : addNews;
      const payload = {
        ...this.form,
        publishTime: this.formatPublishTimeForApi(this.form.publishTime)
      };
      try {
        await request(payload);
        this.$message.success(this.form.newsId ? "修改成功" : "新增成功");
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = defaultForm();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/News/NewsForm.vue